export default __webpack_public_path__ + "static/media/promotion-2.82277c79.jpg";